
import React from 'react';
import Hero from './components/Hero';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
